module.exports = __webpack_public_path__ + "static/media/image011.f1c6b5ce.png";